import React from 'react'
import {withStyles} from '@material-ui/core/styles'
import {Icon, IconButton, Tooltip, Typography} from '@material-ui/core'
import Toolbar from 'react-big-calendar/lib/Toolbar'
import {navigate} from 'react-big-calendar/lib/utils/constants'
import classNames from 'classnames'
import moment from 'moment'
import {bindActionCreators} from "redux"
import ReduxCalender from "../../../../store/actionreducers/calender"
import ReduxNewCalender from "../../../../store/actionreducers/new-calendar"
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import {constDataDialogs} from "../../../../constants"
import connect from "react-redux/es/connect/connect"
import DownloadCalendar from "./DownloadCalendar"

/*const viewNamesObj = {
    month: {
        title: '月',
        icon: 'view_module'
    },
    week: {
        title: '週',
        icon: 'view_week'
    },
    work_week: {
        title: '工作日',
        icon: 'view_array'
    },
    day: {
        title: '天',
        icon: 'view_day'
    },
    agenda: {
        title: '列表',
        icon: 'view_agenda'
    }
}*/

class NewCalendarHeader extends Toolbar {

    _getTitle({date, view, label}) {
        if (view === 'month') return moment(date).format('YYYY 年 MM 月')
        else if (view === 'week') return moment(date).startOf('week').format('MM 月 DD 日') + ' ~ ' + moment(date).endOf('week').format('MM 月 DD 日')
        else if (view === 'work_week') return moment(date).endOf('week').isoWeekday(1).format('MM 月 DD 日') + ' ~ ' + moment(date).endOf('week').isoWeekday(5).format('MM 月 DD 日')
        else if (view === 'day') return moment(date).format('YYYY 年 MM 月 DD 日')
        else if (view === 'agenda') return moment(date).startOf('month').format('YYYY/MM/DD') + ' ~ ' + moment(date).endOf('month').format('YYYY/MM/DD')
        else return label
    }

    _onNavigate(action) {
        const {date, setCalendarDate} = this.props

        let newDate = moment(date)
        switch (action) {
            case navigate.TODAY:
                newDate = moment()
                break
            case navigate.PREVIOUS:
                newDate.subtract(1, 'month')
                break
            case navigate.NEXT:
                newDate.add(1, 'month')
                break
            default:
                // Do nothing
        }

        setCalendarDate({
            year: newDate.year(),
            month: newDate.month(),
        })
    }

    render() {
        const { classes, label, date, view, openDataDialog, reload } = this.props
        return (
            <div className={classNames(classes.root, moment(date).format('MMM'))}>
                <div className="flex flex-1 flex-col p-12 justify-between z-10">
                    <div className="flex flex-col items-center justify-between sm:flex-row">
                        <div className="flex items-center my-16 sm:mb-0">
                            <Icon className="text-32 mx-12">today</Icon>
                            <Typography variant="title" color="inherit">醫師排班</Typography>
                        </div>
                        <div className="flex justify-end">
                            <Tooltip title="Today" disableFocusListener={true}>
                                <IconButton aria-label="today" color="inherit"
                                            onClick={this._onNavigate.bind(this, navigate.TODAY)}>
                                    <Icon>today</Icon>
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Download" disableFocusListener={true}>
                                <IconButton aria-label="download" color="inherit"
                                            onClick={ev => {
                                                ev.stopPropagation()
                                                this.state.updateDateHandler(date)
                                                openDataDialog({
                                                    type: constDataDialogs.type.edit,
                                                    name: constDataDialogs.name.downloadCalendar,
                                                })
                                            }}>
                                    <Icon>get_app</Icon>
                                </IconButton>
                            </Tooltip>

                            {reload && <Tooltip title="Reload" disableFocusListener={true}>
                                <IconButton aria-label="download" color="inherit"
                                            onClick={reload}>
                                    <Icon>refresh</Icon>
                                </IconButton>
                            </Tooltip>}
                        </div>
                    </div>

                    <div className="flex items-center justify-center">
                        <Tooltip title="向前" disableFocusListener={true}>
                            <IconButton aria-label="Previous" color="inherit"
                                        onClick={this._onNavigate.bind(this, navigate.PREVIOUS)}>
                                <Icon color="inherit">chevron_left</Icon>
                            </IconButton>
                        </Tooltip>
                        <Typography variant="title" color="inherit">{this._getTitle({ date, view, label })}</Typography>
                        <Tooltip title="向後" disableFocusListener={true}>
                            <IconButton aria-label="Next" color="inherit"
                                        onClick={this._onNavigate.bind(this, navigate.NEXT)}>
                                <Icon>chevron_right</Icon>
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
                <DownloadCalendar
                    date={date}
                    setUpdateDateHandler={handler => this.setState({ updateDateHandler: handler })}
                />
            </div>
        )
    }
}

const styles = theme => ({
    root: {
        height: 200,
        minHeight: 200,
        display: 'flex',
        backgroundImage: 'url("../../assets/images/backgrounds/header-bg.png")',
        backgroundColor: '#FAFAFA',
        color: '#FFFFFF',
        backgroundSize: 'cover',
        backgroundPosition: '0 50%',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        '&:before': {
            content: "''",
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            zIndex: 1,
            background: 'rgba(0, 0, 0, 0.45)'
        },
        '&.Jan': {
            backgroundImage: "url('/assets/images/backgrounds/winter.jpg')",
            backgroundPosition: '0 85%'
        },
        '&.Feb': {
            backgroundImage: "url('/assets/images/backgrounds/winter.jpg')",
            backgroundPosition: '0 85%'
        },
        '&.Mar': {
            backgroundImage: "url('/assets/images/backgrounds/spring.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Apr': {
            backgroundImage: "url('/assets/images/backgrounds/spring.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.May': {
            backgroundImage: "url('/assets/images/backgrounds/spring.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Jun': {
            backgroundImage: "url('/assets/images/backgrounds/summer.jpg')",
            backgroundPosition: '0 80%'
        },
        '&.Jul': {
            backgroundImage: "url('/assets/images/backgrounds/summer.jpg')",
            backgroundPosition: '0 80%'
        },
        '&.Aug': {
            backgroundImage: "url('/assets/images/backgrounds/summer.jpg')",
            backgroundPosition: '0 80%'
        },
        '&.Sep': {
            backgroundImage: "url('/assets/images/backgrounds/autumn.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Oct': {
            backgroundImage: "url('/assets/images/backgrounds/autumn.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Nov': {
            backgroundImage: "url('/assets/images/backgrounds/autumn.jpg')",
            backgroundPosition: '0 40%'
        },
        '&.Dec': {
            backgroundImage: "url('/assets/images/backgrounds/winter.jpg')",
            backgroundPosition: '0 85%'
        }
    }
})

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getWorkEvents: ReduxCalender.ActionCreator.getWorkEvents,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        setCalendarDate: ReduxNewCalender.ActionCreator.setCalendarDate,
    }, dispatch)
}

function mapStateToProps({global: {dataDialog, dataDialogs},}) {

    return {
        vipDialog: dataDialogs[constDataDialogs.name.vipDialog],
        dataDialog,
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(NewCalendarHeader))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/newCalendar/NewCalendarHeader.js